export default {
	section_banner: {
		title: {
			one: '1 つのテザー',
			two: '得る',
			three: '追加',
		},
		main_title: {
			one: '特典ポイント',
		},
		sub_title: {
			one: '使用することで',
			two: '1 つのテザー',
		},
		paragraph: {
			one: '取引、キャッシュバック オファー、プロモーション コードを利用してお金を節約し、最高のストアやお気に入りのブランドから特典を獲得しましょう。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	maximize_rewards_sec: {
		label: '最速の支払いシステム',
		title: {
			one: 'あなたの能力を最大限に高めます',
			two: '報酬',
		},
		paragraph: {
			one: '取引の組み合わせ、キャッシュバックのご提案、プロモーションコードの利用で、さらにお得にご利用いただけます。お支払い時にプロモーションコードを見つけて適用できるようお手伝いいたします。JPWorldPayなら、スマートなショッピングが簡単かつお得になります。毎回のご購入で、最大限の節約を実現しましょう。',
			two: 'JPWorldPayカードには特典がありますか？ご購入時にご利用いただくと特典が受けられます。ご利用ごとにポイントが貯まり、限定特典もお楽しみいただけます。',
		},
		cta_buttons: 'ショッピングを始める',
	},
	question_sec: {
		label: '選んで取引する',
		title: {
			one: 'あなたの',
			two: '理想的',
			three: '暗号通貨',
		},
		paragraph: {
			one: '私たちは、あなたがどこで買い物をし、購入するかに基づいて、あなたが気に入ると思われるお買い得品、製品、店舗を紹介し、あなたのお気に入りの店舗を増やし、更新し続けることをお約束します。',
		},
		cta_buttons: '始めましょう',
	},
	online_mid: {
		label: 'オンラインショッピング',
		title: {
			one: 'オンラインショッピング',
			two: 'JPWorldPay を使用する',
		},
		paragraph:
			'JPWorldPayで安全にお支払いいただくと、世界中の何百万もの小売業者からの取引特典やキャッシュバック特典をご利用いただけます。お客様の情報は暗号化されており、お客様の許可なく販売または共有されることはありません。ご購入のたびに、迅速、安全、そしてお得なお支払いをお楽しみください。JPWorldPayコミュニティに参加して、デジタル決済をコントロールしましょう。',
		cta_buttons: '始めましょう',
	},
	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
